export default __webpack_public_path__ + "static/cargo-ship-2-1cc1200a244468987960464e531ead19.jpeg";